var paragraph_default = {
  "fontElementMap": "_4xybA",
  "elementSpacing": "pbpjT",
  "text": "-kA22 pbpjT",
  "child": "k6Gbk"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
